import { render, staticRenderFns } from "./ActionsBlock2.vue?vue&type=template&id=69bbca8f&scoped=true&"
import script from "./ActionsBlock2.vue?vue&type=script&lang=js&"
export * from "./ActionsBlock2.vue?vue&type=script&lang=js&"
import style0 from "./ActionsBlock2.vue?vue&type=style&index=0&id=69bbca8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bbca8f",
  null
  
)

export default component.exports